import PropTypes from "prop-types";

import useReadAloudMode from "@/view/ReadAloudControls/useReadAloudMode";
import useUserContentUIContext from "@/view/utils/useUserContentUIContext";
import { levelAlertPlaceholder, rootCss } from "./LevelAlert.style";

const propTypes = {
  levels: PropTypes.array,
};

const LevelAlert = ({ levels }) => {
  const { isReadAloudModeActive } = useReadAloudMode();
  const { uiType } = useUserContentUIContext();

  if (!levels?.length || levels?.length > 1) return null;

  // We don't want to show this alert when read aloud is active,
  // but we do want the space for this alert to be maintained
  // to keep the page from jumping.
  if (isReadAloudModeActive) {
    return <div css={levelAlertPlaceholder(uiType)} />;
  }

  return (
    <div css={rootCss(uiType)}>
      This content is published at the original level only.
    </div>
  );
};

LevelAlert.propTypes = propTypes;

export default LevelAlert;
